/**
 * rb-fonts.js — font-family resolution + print-iframe @font-face injection.
 *
 * Pure leaf module. Two jobs:
 *   1. screenStack(font, locale) — a CSS font-family stack for the on-screen
 *      preview and the print document, picking a Noto family that covers the
 *      current locale's script (Cyrillic / Arabic / CJK) so non-Latin résumés
 *      render correctly.
 *   2. printFontFaceCss(locale) — the @font-face rules to inline into the
 *      print iframe. The browser's "Save as PDF" engine subsets + embeds
 *      these, so the exported PDF carries correct glyphs and selectable text.
 *
 * The jsPDF ATS-PDF path does NOT use this module — it uses the shared
 * window.__pdfLoadUnicodeFont helper (public/js/pdf-fonts.js).
 *
 * globalThis.RbFonts
 */
(function () {
    'use strict';

    var BASE = '/vendor/fonts/';

    /* locale 2-letter -> Noto family covering its script. */
    var LOCALE_FONT = {
        ko: { family: 'RB Noto KR', regular: 'NotoSansKR-Regular.ttf', bold: 'NotoSansKR-Bold.ttf' },
        ja: { family: 'RB Noto JP', regular: 'NotoSansJP-Regular.ttf', bold: 'NotoSansJP-Bold.ttf' },
        zh: { family: 'RB Noto SC', regular: 'NotoSansSC-Regular.ttf', bold: 'NotoSansSC-Bold.ttf' },
        ar: { family: 'RB Noto Arabic', regular: 'NotoSansArabic-Regular.ttf', bold: 'NotoSansArabic-Bold.ttf' }
    };
    /* Latin + Cyrillic default (covers en/de/es/fr/pt/id/ru). */
    var DEFAULT_FONT = { family: 'RB Noto Sans', regular: 'NotoSans-Regular.ttf', bold: 'NotoSans-Bold.ttf' };

    function fontFor(locale) {
        return LOCALE_FONT[(locale || 'en').toString().slice(0, 2)] || DEFAULT_FONT;
    }

    /* A CSS font-family stack. `font` is the template knob (sans|serif|mono|
       grotesk). The locale Noto family is appended as a script-coverage
       fallback after the latin display fonts. */
    function screenStack(font, locale) {
        var noto = fontFor(locale).family;
        switch (font) {
            case 'serif':
                return "Georgia,'Times New Roman','" + noto + "',serif";
            case 'mono':
                return "'Fira Code','SF Mono','JetBrains Mono',Menlo,Consolas,'" + noto + "',monospace";
            case 'grotesk':
                return "'Inter','Helvetica Neue',Arial,'" + noto + "',sans-serif";
            default: /* sans */
                return "'Inter','Segoe UI',Roboto,'" + noto + "',system-ui,sans-serif";
        }
    }

    /* @font-face block for the print iframe — only the current locale family,
       lazy: fetched by the browser when the iframe document loads. */
    function printFontFaceCss(locale) {
        var f = fontFor(locale);
        return "@font-face{font-family:'" + f.family + "';font-weight:400;font-style:normal;" +
               "src:url('" + BASE + f.regular + "') format('truetype');font-display:swap}" +
               "@font-face{font-family:'" + f.family + "';font-weight:700;font-style:normal;" +
               "src:url('" + BASE + f.bold + "') format('truetype');font-display:swap}";
    }

    /* True if the locale needs a non-Latin script font (affects whether the
       preview should preload the family). */
    function isComplexScript(locale) {
        return !!LOCALE_FONT[(locale || 'en').toString().slice(0, 2)];
    }

    globalThis.RbFonts = {
        fontFor: fontFor,
        screenStack: screenStack,
        printFontFaceCss: printFontFaceCss,
        isComplexScript: isComplexScript
    };
})();
